/**
 * Normalize Khmer phone number to remove country code and non-digit characters.
 * @param value Phone number to normalize.
 * @returns Normalized phone number.
 */
export const normalizeKhmerPhoneNumber = (value: string | null | undefined) => {
  const digitsOnly = (value ?? "").replace(/\D/g, "");
  if (!digitsOnly) {
    return "";
  }

  if (digitsOnly.startsWith("855")) {
    return digitsOnly.slice(3);
  }

  return digitsOnly;
};

/**
 * Normalize the country code to be in the format of `+XXX`.
 * @param countryCode Country code to normalize.
 * @returns Normalized country code.
 */
export const normalizePhoneCountryCode = (countryCode?: string) => {
  const normalizedCountryCode = countryCode?.trim();

  if (!normalizedCountryCode) {
    return undefined;
  }

  return normalizedCountryCode.startsWith("+")
    ? normalizedCountryCode
    : `+${normalizedCountryCode}`;
};
